import type { EventKind, WorklogEvent } from './types';

export function eventKind(e: WorklogEvent): EventKind {
  if (e.event === 'note' || e.event === 'NOTE') {
    const cat = (e.category || '').toLowerCase();
    if (cat === 'progress') return 'progress';
    if (cat === 'client') return 'client';
    if (cat === 'consideration') return 'consideration';
    if (cat === 'dashboard') return 'dashboard';
    if (cat === 'link') return 'link';
    return 'general';
  }
  if (e.event === 'link') return 'link';
  if (e.event === 'task') return 'task';
  if (e.event === 'start' || e.event === 'stop') return 'session';
  if (e.event === 'pause' || e.event === 'resume') return 'pause';
  if (e.event === 'contract-start' || e.event === 'contract-end') return 'contract';
  if (e.event === 'subtract') return 'subtract';
  if (e.event === 'correct') return 'correct';
  if (e.event === 'item-status' || e.event === 'item-state') return 'status-change';
  if (e.event === 'task-time' || e.event === 'block' || e.event === 'unspecified-time') return 'time-slice';
  if (e.event === 'revise') return 'revise';
  return 'other';
}

export const KIND_LABELS: Record<EventKind, string> = {
  progress: 'Progress',
  client: 'Client',
  consideration: 'Consideration',
  dashboard: 'Dashboard',
  general: 'Note',
  link: 'Link',
  task: 'Sub-task',
  session: 'Session',
  pause: 'Pause/resume',
  contract: 'Contract',
  subtract: 'Time edit',
  correct: 'Correction',
  'status-change': 'Status change',
  'time-slice': 'Time slice',
  revise: 'Revision',
  other: 'Other',
};

export const DEFAULT_KIND_VISIBILITY: Record<EventKind, boolean> = {
  progress: true,
  client: true,
  consideration: true,
  dashboard: true,
  general: true,
  link: true,
  task: true,
  session: true,
  pause: true,
  contract: true,
  subtract: true,
  correct: true,
  'status-change': true,
  'time-slice': false,
  revise: true,
  other: false,
};

export interface ViewMode {
  id: 'day' | 'list' | 'session';
  label: string;
}

export const VIEW_MODES: ViewMode[] = [
  { id: 'day', label: 'By day' },
  { id: 'list', label: 'List' },
  { id: 'session', label: 'By session' },
];
